"use client";

import React, { useEffect, useState } from "react";
import type { DbTimeString } from "@openings/api-client";

import { slotsContainerStyle } from "../bookingStyles";
import TimeButton from "./TimeButton";

type TimeGridProps = {
  times: DbTimeString[];
  getLabel: (time: DbTimeString) => string;
  onSelect: (time: DbTimeString) => void;
  resetKey: string;
  selectionEnabled?: boolean;
  selectedTime?: DbTimeString | null;
  onSelectedTimeChange?: (time: DbTimeString) => void;
  columnCount?: number;
};

export function TimeGrid({
  times,
  getLabel,
  onSelect,
  resetKey,
  selectionEnabled = true,
  selectedTime,
  onSelectedTimeChange,
  columnCount,
}: TimeGridProps) {
  const [localSelectedTime, setLocalSelectedTime] =
    useState<DbTimeString | null>(null);
  const effectiveSelectedTime =
    selectedTime === undefined ? localSelectedTime : selectedTime;

  useEffect(() => {
    setLocalSelectedTime(null);
  }, [resetKey]);

  return (
    <div
      className="openings-time-grid"
      style={
        columnCount
          ? {
              ...slotsContainerStyle,
              gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
            }
          : slotsContainerStyle
      }
    >
      {times.map((time, timeIndex) => (
        <TimeButton
          key={`${time}-${timeIndex}`}
          onClick={() => {
            if (selectionEnabled) {
              if (selectedTime === undefined) setLocalSelectedTime(time);
              onSelectedTimeChange?.(time);
            }
            onSelect(time);
          }}
          label={getLabel(time)}
          time={time}
          isSelected={
            selectionEnabled
              ? effectiveSelectedTime === time
              : undefined
          }
        />
      ))}
    </div>
  );
}
